/* unplugin-vue-components disabled */import script from "./race-info.vue?vue&type=script&lang=jsx"
export * from "./race-info.vue?vue&type=script&lang=jsx"

import "./race-info.vue?vue&type=style&index=0&id=4cfb6424&lang=css&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cfb6424"]])

export default __exports__